import { render, staticRenderFns } from "./CollectionContentContainer.vue?vue&type=template&id=c4eb6826&scoped=true&"
import script from "./CollectionContentContainer.vue?vue&type=script&lang=js&"
export * from "./CollectionContentContainer.vue?vue&type=script&lang=js&"
import style0 from "./CollectionContentContainer.vue?vue&type=style&index=0&id=c4eb6826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4eb6826",
  null
  
)

export default component.exports